import React, { useEffect, useRef, useState } from "react";
import HomeScreen from "./screens/HomeScreen";
import LoginScreen from "./screens/LoginScreen";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import QuestionsScreen from "./screens/QuestionsScreen";
import "react-circular-progressbar/dist/styles.css";
import NewQuestionScreen from "./screens/NewQuestionScreen";
import ProductsScreen from "./screens/ProductsScreen";
import NewsScreen from "./screens/NewsScreen";
import AlertsScreen from "./screens/AlertsScreen";
import ModeratorScreen from "./screens/ModeratorScreen";
import {
  getAllAlerts,
  getManagerAlerts,
  getManagerVideos,
} from "./actions/alertActions";
import { SOCKET_URL } from "./contants/allConstants";
import { io } from "socket.io-client";
import { getAllNotifications } from "./actions/notificationActions";
import { getAllTeams } from "./actions/teamActions";
import SupervisorsScreen from "./screens/SupervisorsScreen";
import SupportScreen from "./screens/SupportScreen";
// import AboutTeamScreen from "./screens/AboutTeamScreen";
import NewTeamScreen from "./screens/NewTeamScreen";
import TeamsScreen from "./screens/TeamsScreen";
import ChangePwdScreen from "./screens/ChangePwdScreen";
import "./i18n";
import { LanguageContextProvider } from "./languageContext";
import VideosScreen from "./screens/VideosScreen";
import VideosManagersScreen from "./screens/VideosManagersScreen";
import AlertsManagersScreen from "./screens/AlertsManagersScreen";
import ResetPasswordScreen from "./screens/ResetPasswordScreen";
import QuestionManagersScreen from "./screens/QuestionManagersScreen";
import DeleteAccount from "./screens/DeleteAccount";
import PrivacyPolicy from "./screens/Policy";

const App = () => {
  const { userInfo } = useSelector((state) => state.userLogin);
  const [openSupport, setSupport] = useState(false);
  const socket = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    if (window.location.pathname === "/dashboard/support") {
      setSupport(true);
    } else if (userInfo) {
      setSupport(false);
      socket.current = io(SOCKET_URL);
    }
  }, []);
  useEffect(() => {
    if (socket.current) {
      socket.current.on("update-alerts", (msg) => {
        if (userInfo.isAlertsManager) {
          dispatch(
            getManagerAlerts(userInfo["token"], "", "", "", userInfo["_id"])
          );
        } else {
          dispatch(getAllAlerts(userInfo["token"], userInfo["_id"], "alert"));
        }
      });

      socket.current.on("update-videos", (msg) => {
        if (userInfo.isVideosManager) {
          dispatch(getManagerVideos(userInfo.token, "", "", "", userInfo._id));
        } else {
          dispatch(getAllAlerts(userInfo["token"], userInfo["_id"], "video"));
        }
      });

      socket.current.on("update-notifications", (msg) => {
        dispatch(getAllNotifications(userInfo["token"], userInfo["_id"]));
      });
    }
  }, [socket.current]);

  return (
    <LanguageContextProvider>
      {window.location.pathname.includes("/policy") ? (
        <PrivacyPolicy />
      ): window.location.pathname.includes("/delete-account") ? (
        <DeleteAccount />
      ):window.location.pathname.includes("/reset-password") ? (
        <ResetPasswordScreen />
      ) : openSupport ? (
        <SupportScreen />
      ) : !userInfo ? (
        <LoginScreen />
      ) : userInfo.isBlocked ? (
        <LoginScreen />
      ) : (
        <main>
          <Router>
            <Switch>
              <Route path="/dashboard/login" component={LoginScreen} />
              {userInfo.isJournalist ? (
                <Route path="/dashboard/" component={NewsScreen} exact />
              ) : userInfo.isAlertsManager ? (
                <Route path="/dashboard/" component={AlertsScreen} exact />
              ) : userInfo.isVideosManager ? (
                <Route path="/dashboard/" component={VideosScreen} exact />
              ) : userInfo.isQuestionManager ? (
                <Route path="/dashboard/" component={QuestionsScreen} exact />
              ) : (
                <Route path="/dashboard/" component={HomeScreen} exact />
              )}
              <Route path="/dashboard/questions" component={QuestionsScreen} />
              <Route path="/dashboard/alerts" component={AlertsScreen} />
              <Route path="/dashboard/videos" component={VideosScreen} />
              <Route path="/dashboard/password" component={ChangePwdScreen} />
              <Route
                path="/dashboard/supervisors"
                component={SupervisorsScreen}
              />
              <Route
                path="/dashboard/new-question"
                component={NewQuestionScreen}
              />
              <Route path="/dashboard/products" component={ProductsScreen} />
              <Route path="/dashboard/news" component={NewsScreen} />
              <Route path="/dashboard/moderator" component={ModeratorScreen} />
              {/* <Route path="/dashboard/about-team" component={AboutTeamScreen} /> */}
              <Route path="/dashboard/new-team" component={NewTeamScreen} />
              <Route path="/dashboard/teams" component={TeamsScreen} />
              <Route
                path="/dashboard/videosmanagers"
                component={VideosManagersScreen}
              />
              <Route
                path="/dashboard/alertsmanagers"
                component={AlertsManagersScreen}
              />
              <Route
                path="/dashboard/questionmanagers"
                component={QuestionManagersScreen}
              />
              <Route
                path="/reset-password/:token"
                component={ResetPasswordScreen}
              />
              <Route
                path="/reset-password/:token"
                component={ResetPasswordScreen}
              />
              :
              <Route path="/support" component={SupportScreen} />
              <Redirect to="/dashboard/" />
            </Switch>
          </Router>
        </main>
      )}
    </LanguageContextProvider>
  );
};

export default App;
